import Splide from '@splidejs/splide';

window.Splide = Splide

window.debounce = require('lodash.debounce');

window.InitSplide = function(el, options = {}) {
	return new Splide(el, options).mount()
}

window.AnimateCSS = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`
        const node = element
        
        node.addClass(`${prefix}animated`)
        node.addClass(`${animationName}`)
        
        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation()
            node.removeClass(`${prefix}animated`)
            node.removeClass(`${animationName}`)
            resolve('Animation ended')
        }
        
        node.on('animationend', handleAnimationEnd)
    }
)

Number.prototype.format = function(n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}